import React, { useEffect, useState } from 'react';
import Selector, { SelectOptions } from '../../../selectors/Selector';
import _ from 'lodash';
import { useIsMount } from '../../../../hooks/useIsMountHook';

interface FindAndReplaceTaggerProps {
  selected: string[];
  onChange: (selection: string[]) => void;
}

enum FindAndReplaceEnum {
  PATH = 'Path',
  PARAM = 'Query Parameters',
  COOKIE = 'Cookies',
  REQUEST_HEADER = 'Request Headers',
  REQUEST_BODY = 'Request Body',
  PROXY_URL = 'Proxy URL',
  RESPONSE_BODY = 'Response Body',
  RESPONSE_HEADERS = 'Response Headers',
  ALL = 'Everywhere',
}

const dropdownItems = (Object.keys(FindAndReplaceEnum) as (keyof typeof FindAndReplaceEnum)[]).map((key, index) => {
  return { value: key, label: FindAndReplaceEnum[key].valueOf() };
});

/**
 * Lets you select predefined locations in Find & Replace functionality
 * @constructor
 */
const FindAndReplaceTagger = (props: FindAndReplaceTaggerProps) => {
  /**
   * Maps selected items from list of strings provided through props to internal option structure.
   */
  const mapSelectedItems = () =>
    props.selected.map(item => {
      return { value: item, label: FindAndReplaceEnum[item] };
    });

  const [selected, setSelected] = useState(mapSelectedItems());
  const isMount = useIsMount();

  useEffect(() => {
    if (!isMount) {
      const selectedStrings = _.map(selected, item => item.value);
      props.onChange(selectedStrings);
    }
  }, [selected]);

  /**
   * If "any" is contained in the selection, we need to remove all other items.
   * @param selection
   */
  const onSelectHandler = (selection: SelectOptions[]) => {
    const isAllOptionAlreadySelected = _.findIndex(selected, item => item.value === FindAndReplaceEnum.ALL) !== -1;
    const isSelectAll = _.findIndex(selection, item => item.label === FindAndReplaceEnum.ALL) !== -1;
    const selectAllOption = [{ value: 'ALL', label: FindAndReplaceEnum.ALL.valueOf() }];

    //If all items are selected, use select all
    if (selection && selection.length === Object.keys(FindAndReplaceEnum).length - 1 && !isSelectAll) {
      setSelected(selectAllOption);
    }
    //If we are selecting all, use just this option
    else if (isSelectAll && !isAllOptionAlreadySelected) {
      setSelected(selectAllOption);
    }
    //Remove existing "ALL" from current selection
    else {
      const filtered = _.filter(selection, item => item.label !== FindAndReplaceEnum.ALL);
      setSelected(filtered);
    }
  };

  return (
    <Selector
      selected={selected}
      placeholder={'Select Location for Find & Replace'}
      isMulti={true}
      options={dropdownItems}
      onSelectionChange={onSelectHandler}
    />
  );
};

export default FindAndReplaceTagger;
